import { RuleTableCell } from "./RuleTableCell";
import { DataUtilities } from "../../../../Common/DataUtilities";
import { ResultCell } from "../../Common/ResultCell";

export class RuleTableRow {
    _id: string = DataUtilities.generateUniqueId();

    ruleCells: { [id: string]: RuleTableCell } = {};
    resultCellsData: { [id: string]: ResultCell } = {};

    get cells(): RuleTableCell[] {
        return Object.values(this.ruleCells);
    }

    get resultCells(): ResultCell[] {
        return Object.values(this.resultCellsData);
    }

    getStorageData(): object {
        let d = {};

        let cells: object[] = [];

        for (let c of this.cells) {
            cells.push(c.getStorageData());
        }

        Reflect.set(d, "cells", cells);

        let rcells: object[] = [];

        for (let c of this.resultCells) {
            rcells.push(c.getStorageData());
        }

        Reflect.set(d, "rcells", rcells);

        return d;
    }

    setStorageData(data: object): void {
        let cells: object[] = Reflect.get(data, "cells");

        for (let c of cells) {
            let newCell = new RuleTableCell("tempid");
            newCell.setStorageData(c);
            this.ruleCells[Reflect.get(c, "_columnId")] = newCell;
        }

        let rcells: object[] = Reflect.get(data, "rcells");

        for (let c of rcells) {
            let newCell = new ResultCell("tempid");
            newCell.setStorageData(c);
            this.resultCellsData[Reflect.get(c, "_columnId")] = newCell;
        }
    }
}
